<template>
    <div class="row">
        <div class="col-md-12">
            <div id="recruitment-checking">
                <h3>اطلاعات اولیه:</h3>
                <div>
                    <strong>نام:</strong>
                    <span>{{finalModel.personalInfo.firstName}}</span>
                </div>
                <div>
                    <strong>نام خانوادگی:</strong>
                    <span>{{finalModel.personalInfo.lastName}}</span>
                </div>
                <div>
                    <strong>نام پدر‌:</strong>
                    <span>{{finalModel.personalInfo.familyInfo.fatherName}}</span>
                </div>
                <div>
                    <strong>تاریخ تولد:</strong>
                    <span>{{finalModel.personalInfo.birthDate}}</span>
                </div>
                <div>
                    <strong>شماره شناسنامه:</strong>
                    <span>{{finalModel.personalInfo.birthCertificateNumber}}</span>
                </div>
                <div>
                    <strong> کدملی:</strong>
                    <span>{{finalModel.personalInfo.ssn}}</span>
                </div>
                <div>
                    <strong>محل‌ تولد‌:</strong>
                    <span>{{finalModel.personalInfo.placeOfBirth}}</span>
                </div>
                <div>
                    <strong>محل‌ صدور‌‌:</strong>
                    <span>{{finalModel.personalInfo.placeOfIssueBirthCertificate}}</span>
                </div>
                <div>
                    <strong>جنسیت‌‌‌:</strong>
                    <span v-if="finalModel.personalInfo.gender==0">مذکر</span>
                    <span v-if="finalModel.personalInfo.gender==1">مونث</span>

                </div>
                <div v-if="finalModel.personalInfo.gender==0">
                    <strong>وضعیت خدمت‌‌‌:</strong>
                    <span>
                        <span v-if="finalModel.personalInfo.militaryServiceInfo.militaryCondition==0">پايان خدمت</span>
                        <span v-if="finalModel.personalInfo.militaryServiceInfo.militaryCondition==1">خرید خدمت</span>
                        <span v-if="finalModel.personalInfo.militaryServiceInfo.militaryCondition==2">معافیت</span>
                    </span>
                </div>
                <div v-if="finalModel.personalInfo.gender==0">
                    <strong>آیا دارای مدرک معافیت هستید؟‌‌‌‌:</strong>
                    <span><span v-if="finalModel.personalInfo.militaryServiceInfo.hasExemptionDocument=='true'">بلی</span></span>
                </div>
                <div v-if="finalModel.personalInfo.militaryServiceInfo.hasExemptionDocument=='true'">
                    <strong>نوع معافیت‌‌‌‌:</strong>
                    <span>{{finalModel.personalInfo.militaryServiceInfo.exemptionType}}</span>
                </div>
                <div>
                    <strong>وضعیت تاهل‌‌‌‌:</strong>
                    <span>
                        <span v-if="finalModel.personalInfo.familyInfo.maritalStatus=='0'">متاهل</span>
                        <span v-if="finalModel.personalInfo.familyInfo.maritalStatus=='1'">مجرد</span>
                    </span>
                </div>
                <div v-if="finalModel.personalInfo.familyInfo.maritalStatus=='0'">
                    <strong>نام و نام خانوادگي همسر:</strong>
                    <span>{{finalModel.personalInfo.familyInfo.spouseName}}</span>
                </div>
                <div v-if="finalModel.personalInfo.familyInfo.maritalStatus=='0'">
                    <strong> شغل همسر:</strong>
                    <span>{{finalModel.personalInfo.familyInfo.spouseJob}}</span>
                </div>
                <div v-if="finalModel.personalInfo.familyInfo.maritalStatus=='0'">
                    <strong>تلفن محل كار همسر:</strong>
                    <span>{{finalModel.personalInfo.familyInfo.spouseWorkplacePhoneNumber}}</span>
                </div>
                <div>
                    <strong>تعداد افراد تحت تكفل:</strong>
                    <span>{{finalModel.personalInfo.familyInfo.numberOfUnderTheTutelagePeople}}</span>
                </div>
                <div>
                    <strong>تعداد فرزندان :</strong>
                    <span>{{finalModel.personalInfo.familyInfo.numberOfChildren}}</span>
                </div>
                <div>
                    <strong>نوع مالكیت محل سكونت‌:</strong>
                    <span>
                        <span v-if="finalModel.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence==0">استیجاری</span>
                        <span v-if="finalModel.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence==1">شخصی</span>
                    </span>
                </div>
                <div v-if="finalModel.personalInfo.residenceInfo.typeOfOwnershipOfTheResidence==0">
                    <strong>مبلغ اجاره:‌</strong>
                    <span>{{finalModel.personalInfo.residenceInfo.rentAmount}}</span>
                </div>
                <div>
                    <strong>تلفن منزل:</strong>
                    <span>{{finalModel.personalInfo.residenceInfo.phoneNumber}}</span>
                </div>
                <div>
                    <strong>تلفن همراه:</strong>
                    <span>{{finalModel.personalInfo.contactInfo.phoneNumber}}</span>
                </div>
                <div>
                    <strong>تلفن ديگر تماس:</strong>
                    <span>{{finalModel.personalInfo.contactInfo.secondaryPhoneNumber}}</span>
                </div>
                <div>
                    <strong>پست الكترونیكی‌:</strong>
                    <span>{{finalModel.personalInfo.contactInfo.email}}</span>
                </div>
                <div>
                    <strong>نشانی كامل محل سكونت‌:</strong>
                    <span>{{finalModel.personalInfo.residenceInfo.address}}</span>
                </div>
                <div>
                    <strong>آيا تاكنون در استخدام اين شركت بوده ايد و يا در اين شركت مصاحبه استخدامی داشته ايد؟‌‌</strong>
                    <span v-if="finalModel.personalInfo.pastRelationWithCompany.hasRelation==true">بلی</span>
                    <span v-if="finalModel.personalInfo.pastRelationWithCompany.hasRelation==false">خیر</span>
                </div>
                <div v-if="finalModel.personalInfo.pastRelationWithCompany.hasRelation==true">
                    <strong>تاريخ ها و سوابق را ذكر كنید:‌</strong>
                    <span>{{finalModel.personalInfo.pastRelationWithCompany.description}}</span>
                </div>
                <div>
                    <strong>آيا تاكنون محكوميت كيفري داشته ايد ؟‌‌</strong>
                    <span v-if="finalModel.personalInfo.criminalConviction.hasCriminalConviction==true">بلی</span>
                    <span v-if="finalModel.personalInfo.criminalConviction.hasCriminalConviction==false">خیر</span>
                </div>
                <div v-if="finalModel.personalInfo.criminalConviction.hasCriminalConviction==true">
                    <strong>نوع محكوميت:‌</strong>
                    <span>{{finalModel.personalInfo.criminalConviction.description}}</span>
                </div>
                <h3>تحصیلات:</h3>
                <div class="wrapper" v-for="(info, index) in finalModel.educationInfos" :key="index">
                    <div>
                        <strong>نام كامل دانشگاه‌:</strong>
                        <span>{{info.instituteName}}</span>
                    </div>
                    <div>
                        <strong>مدرك تحصیلی‌:</strong>
                        <span v-if="info.degree==1">دیپلم</span>
                        <span v-if="info.degree==2">کاردانی</span>
                        <span v-if="info.degree==3">کارشناسی</span>
                        <span v-if="info.degree==4">کارشناسی ارشد</span>
                        <span v-if="info.degree==5">دکتری</span>
                    </div>
                    <div>
                        <strong>رشته تحصیلی‌:</strong>
                        <span>{{info.fieldOfStudy}}</span>
                    </div>
                    <div>
                        <strong>تاريخ شروع‌:</strong>
                        <span>{{info.startDate}}</span>
                    </div>
                    <div>
                        <strong>تاريخ پايان‌:</strong>
                        <span>{{info.endDate}}</span>
                    </div>
                    <div>
                        <strong>معدل‌:</strong>
                        <span>{{info.rate}}</span>
                    </div>
                </div>
                <h3>سوابق كاری:</h3>
                <div class="wrapper" v-for="(workHistory, index) in finalModel.workHistories" :key="'index'+index">
                    <h4 v-if="index==0">محل كار كنونی/آخرين محل كار:</h4>
                    <h4 v-if="index!=0 && (workHistory.companyName || workHistory.companyFieldOfActivity)">محل كار قبلی</h4>
                    <div class="wrapper" v-if="index==0 || (workHistory.companyName || workHistory.companyFieldOfActivity)">
                        <div>
                            <strong>نام شرکت‌:</strong>
                            <span>{{workHistory.companyName}}</span>
                        </div>
                        <div>
                            <strong>زمینه فعالیت شرکت:</strong>
                            <span>{{workHistory.companyFieldOfActivity}}</span>
                        </div>
                        <div>
                            <strong> سمت/شغل‌:‌</strong>
                            <span>{{workHistory.post}}</span>
                        </div>
                        <div>
                            <strong> تعداد کارکنان:‌</strong>
                            <span>{{workHistory.employeesCount}}</span>
                        </div>
                        <div>
                            <strong>تاریخ شروع همکاری:</strong>
                            <span>{{workHistory.startOfWork}}</span>
                        </div>
                        <div>
                            <strong>تاریخ پایان همکاری:</strong>
                            <span>{{workHistory.endOfWork}}</span>
                        </div>
                        <div>
                            <strong>نام سرپرست/مدیر مستقیم‌:‌</strong>
                            <span>{{workHistory.bossName}}</span>
                        </div>
                        <div>
                            <strong>علت خاتمه/تمايل به خاتمه همكاری:</strong>
                            <span>{{workHistory.reasonOfTerminationOfCooperation}}</span>
                        </div>
                        <div>
                            <strong>حقوق و مزايای اولیه:</strong>
                            <span>{{workHistory.primarySalaryAndBenefits}}</span>
                        </div>
                        <div>
                            <strong>آخرين حقوق و مزايا:</strong>
                            <span>{{workHistory.lastSalaryAndBenefits}}</span>
                        </div>
                        <div>
                            <strong>مسئولیت های شما‌:</strong>
                            <span>{{workHistory.responsibilities}}</span>
                        </div>
                        <div>
                            <strong>تلفن تماس:‌</strong>
                            <span>{{workHistory.phoneNumber}}</span>
                        </div>
                        <div>
                            <strong> آیا مجاز به تماس هستیم؟</strong>
                            <span v-if="workHistory.canContact==true">بلی</span>
                            <span v-if="workHistory.canContact==false">خیر</span>
                        </div>
                    </div>
                </div>
                <h3>موارد مربوط به بهداشت و درمان:</h3>
                <div>
                    <strong>گروه خوني :</strong>
                    <span style="direction:ltr">{{finalModel.healthCareInfo.bloodType}}</span>
                </div>
                <div>
                    <strong>
                        آيا بيماري خاصي داريد؟
                    </strong>
                    <span v-if="finalModel.healthCareInfo.specialDisease">بلی، {{finalModel.healthCareInfo.specialDisease}}</span>
                    <span v-else>خیر</span>
                </div>
                <div>
                    <strong>آيا عادت به مصرف دخانيات ، داروي خاص ، ... داريد؟</strong>
                    <span v-if="finalModel.healthCareInfo.tobaccoSpecialMedicine">بلی، {{finalModel.healthCareInfo.tobaccoSpecialMedicine}}</span>
                    <span v-else>خیر</span>
                </div>
                <h3>فعالیت‌هاو مهارت‌ها:</h3>
                <h4>دوره‌های آموزشی/تخصصی</h4>
                <div class="wrapper" v-for="(course, index) in finalModel.specializedCourses" :key="'course'+index">
                    <div>
                        <strong>نام دوره:</strong>
                        <span>{{course.courseName}}</span>
                    </div>
                    <div>
                        <strong>سال:</strong>
                        <span>{{course.year}}</span>
                    </div>
                    <div>
                        <strong>مدت‌:</strong>
                        <span>{{course.period}}</span>
                    </div>
                    <div>
                        <strong>نام كامل موسسه‌:</strong>
                        <span>{{course.instituteName}}</span>
                    </div>
                    <div>
                        <strong>محل برگزاری:</strong>
                        <span>{{course.location}}</span>
                    </div>
                    <div>
                        <strong>گواهي پايان دوره‌:</strong>{{course.hasDegree}}
                        <span v-if="course.hasDegree==true">بلی</span>
                        <span v-if="course.hasDegree==false">خیر</span>
                    </div>
                </div>
                <h4>مهارت‌ها</h4>
                <div>
                    <strong>زبان خارجی۱‌:</strong>
                    <span>{{finalModel.skillInfo.firstLanguage}}</span>
                </div>
                <div>
                    <strong>سطح‌:</strong>
                    <span>{{finalModel.skillInfo.firstLanguageLevel}}</span>
                </div>
                <div class="wrapper" v-if="finalModel.skillInfo.secondLanguage">
                    <div>
                        <strong>زبان خارجی۲‌:</strong>
                        <span>{{finalModel.skillInfo.secondLanguage}}</span>
                    </div>
                    <div>
                        <strong>سطح‌:</strong>
                        <span>{{finalModel.skillInfo.secondLanguageLevel}}</span>
                    </div>
                </div>
                <div>
                    <strong>مهارت‌های کامپیوتری‌:</strong>
                    <span>{{finalModel.skillInfo.computerSkills}}</span>
                </div>
                <div>
                    <strong>سایر مهارت‌های کامپیوتری كه با آن‌ها آشنايي داريد‌:</strong>
                    <span>{{finalModel.skillInfo.otherComputerSkills}}</span>
                </div>
                <div>
                    <strong>سخت افزارهايي كه با آن‌ها آشنايي داريد:</strong>
                    <span>{{finalModel.skillInfo.hardwareKnowledge}}</span>
                </div>
                <div>
                    <strong>سایر مهارت‌ها(فنی،حرفه‌ایی):</strong>
                    <span>{{finalModel.skillInfo.otherTechnicalSkills}}</span>
                </div>
                <div>
                    <strong>موفقیت‌های خاص:</strong>
                    <span>{{finalModel.skillInfo.specialSuccess}}</span>
                </div>
                <div>
                    <strong>آيا گواهینامه رانندگی داريد؟</strong>
                    <span v-if="finalModel.skillInfo.hasDrivingLicense=='true'">بلی</span>
                    <span v-else>خیر</span>
                </div>
                <div class="wrapper" v-if="finalModel.skillInfo.hasDrivingLicense=='true'">
                    <div>
                        <strong>نوع پایه:</strong>
                        <span>{{finalModel.skillInfo.drivingLicenseBase}}</span>
                    </div>
                    <div>
                        <strong>سال اخذ:</strong>
                        <span>{{finalModel.skillInfo.drivingLicenseYear}}</span>
                    </div>
                </div>
                <div>
                    <strong>آيا تاكنون سفر خارج از كشور رفته ايد؟</strong>
                    <span v-if="finalModel.travelAbroadInfos[0].country.length>0">بلی</span>
                    <span v-else>خیر</span>
                </div>
                <div class="wrapper" v-if="finalModel.travelAbroadInfos[0].country.length>0" v-for="(travelInfo, index) in finalModel.travelAbroadInfos" :key="'travelInfo'+index">
                    <div>
                        <strong>نام كشور:‌</strong>
                        <span>{{travelInfo.country}}</span>
                    </div>
                    <div>
                        <strong>سال سفر:</strong>
                        <span>{{travelInfo.year}}</span>
                    </div>
                    <div>
                        <strong>علت سفر:</strong>
                        <span>{{travelInfo.reason}}</span>
                    </div>
                </div>
                <div class="option-list">
                    <strong>فعاليتها و سرگرمي هاي اوقات فراغت: </strong>
                    <span v-if="finalModel.entertainments.reading==true">مطالعه </span>
                    <span v-if="finalModel.entertainments.sport==true"> ورزش</span>
                    <span v-if="finalModel.entertainments.membershipInVariousCenters==true">عضويت در مراكز مختلف </span>
                    <span v-if="finalModel.entertainments.charitableActivities==true"> فعالیت در امور خیريه</span>
                    <span v-if="finalModel.entertainments.others"> {{finalModel.entertainments.others}}</span>
                </div>
                <h3>سایر اطلاعات</h3>
                <h4>نحوه مراجعه/ارتباط</h4>
                <div class="option-list">
                    <strong>از چه طریق با آواژنگ آشنا شده اید؟</strong>
                    <span v-if="finalModel.referralInfo.isFromAdvertising==true">آگهی:{{finalModel.referralInfo.advertising}} <span v-if="finalModel.referralInfo.advertisingDate.length>0">-مورخ: {{finalModel.referralInfo.advertisingDate}}</span></span>
                    <span v-if="finalModel.referralInfo.isFromOtherPerson==true">معرفي افراد :{{finalModel.referralInfo.referralPerson}}</span>
                    <span v-if="finalModel.referralInfo.isOtherWays==true">سایر :{{finalModel.referralInfo.otherWaysDescription}}</span>
                </div>
                <div>
                    <strong>آيا با كاركنان این شرکت آشنايي و يا نسبتي داريد؟</strong>
                    <span v-if="finalModel.referralInfo.hasRelationWithOtherEmployee==true">بلی</span>
                    <span v-else>خیر</span>
                </div>
                <div v-if="finalModel.referralInfo.hasRelationWithOtherEmployee==true">
                    <strong>لطفا" با ذكر نام همكار ، توضيح دهيد:</strong>
                    <span>{{finalModel.referralInfo.employeeName}}</span>
                </div>
                <div>
                    <strong>لطفا" 3 نفر ( بغير از بستگان درجه يك ) كه مي توانند شناخت خود را از خصوصيات ، يا توانايي حرفه اي شما دراختيار ما بگذارند را ذكر نمائيد:</strong>
                </div>
                <div class="wrapper" v-for="(info, index) in finalModel.relationInfos.filter(x => x.isFirstDegreeRelative === true)" :key="'info'+index">
                    <div>
                        <strong>نام:</strong>
                        <span>{{info.name}}</span>
                    </div>
                    <div>
                        <strong>نسبت:</strong>
                        <span>{{info.relation}}</span>
                    </div>
                    <div>
                        <strong>محل فعاليت:</strong>
                        <span>{{info.workCompany}}</span>
                    </div>
                    <div>
                        <strong>سمت/نوع فعاليت:</strong>
                        <span>{{info.post}}</span>
                    </div>
                    <div>
                        <strong>تلفن هاي تماس‌:</strong>
                        <span>{{info.phoneNumber}}</span>
                    </div>
                </div>
                <h4>اطلاعات بستگان درجه یک:</h4>
                <div>
                    <strong>لطفا نام دو نفر از اعضای خانواده را جهت موارد اضطراری ذکر نمائید:</strong>
                </div>
                <div class="wrapper" v-for="(info, index) in finalModel.relationInfos.filter(x => x.isFirstDegreeRelative === false)" :key="'info-'+index">
                    <div>
                        <strong>نام:</strong>
                        <span>{{info.name}}</span>
                    </div>
                    <div>
                        <strong>نسبت:</strong>
                        <span>{{info.relation}}</span>
                    </div>
                    <div>
                        <strong>تلفن هاي تماس‌:</strong>
                        <span>{{info.phoneNumber}}</span>
                    </div>
                </div>
                <h4>شغل مورد نظر:</h4>
                <div>
                    <strong>شغل/زمينه هاي همكاري موردنظر خود را نام ببريد‌:</strong>
                    <span>{{finalModel.requestedJobInfo.typesOfCooperation}}</span>
                </div>
                <div>
                    <strong>زمان آمادگي براي شروع كار:‌</strong>
                    <span>{{finalModel.requestedJobInfo.readyForCooperationDate}}</span>
                </div>
                <div>
                    <strong>ميزان حقوق درخواستی (ريال):</strong>
                    <span>{{finalModel.requestedJobInfo.requestedSalary}}</span>
                </div>
                <div>
                    <strong> آيا امكان حضور در زمان خارج از وقت اداري را داريد؟‌</strong>
                    <span v-if="finalModel.requestedJobInfo.canParticipateInOutOfOfficeHours==true">بلی</span>
                    <span v-else>خیر</span>
                </div>
                <div>
                    <strong>پیوست رزومه:‌</strong>
                    <span v-if="finalModel.cv.length>0"><i class="avafont-checkmark attached"></i></span>
                    <span v-else><i class="avafont-close not-attached"></i></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            finalModel: {
                type: Object,
                default: ''
            }
        },
    };
</script>